import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

const DEFAULTS = {
  selector: 'h1, h2, h3, h4, h5, h6',
  excludeSelector: '[data-no-heading-animate], header, footer, nav, .shopify-section-header, .shopify-section-footer, .rte h1, .rte h2, .rte h3, .rte h4, .rte h5, .rte h6',
  mobileMedia: '(max-width: 767px)',
  stagger: 0.1,
  duration: 0.8,
  ease: 'power4.out',
  y: 30,
  start: 'top 85%',
  once: true,
  autoSplit: true,
};

const splits = [];

function shouldSkip(heading, excludeSelector) {
  if (!heading.textContent?.trim()) return true;
  if (heading.closest(excludeSelector)) return true;
  if (heading.dataset.headingAnimated === 'true') return true;

  return false;
}

function revealHeading(heading) {
  gsap.set(heading, { opacity: 1 });
}

function animateHeading(heading, config) {
  const split = SplitText.create(heading, {
    type: 'lines',
    linesClass: 'heading-line++',
    autoSplit: config.autoSplit,
    onSplit(self) {
      revealHeading(heading);

      gsap.set(self.lines, {
        opacity: 0,
        y: config.y,
      });

      return gsap.to(self.lines, {
        opacity: 1,
        y: 0,
        duration: config.duration,
        ease: config.ease,
        stagger: config.stagger,
        scrollTrigger: {
          trigger: heading,
          start: config.start,
          once: config.once,
        },
      });
    },
  });

  heading.dataset.headingAnimated = 'true';
  splits.push(split);

  return split;
}

export default function initHeadingAnimations(options = {}) {
  const config = { ...DEFAULTS, ...options };

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
    || window.matchMedia(config.mobileMedia).matches
  ) {
    document.querySelectorAll(config.selector).forEach(revealHeading);
    return { splits, refresh: () => {} };
  }

  document.querySelectorAll(config.selector).forEach((heading) => {
    if (shouldSkip(heading, config.excludeSelector)) {
      revealHeading(heading);
      return;
    }

    animateHeading(heading, config);
  });

  ScrollTrigger.refresh();

  return {
    splits,
    refresh() {
      ScrollTrigger.refresh();
    },
  };
}
